import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AuthService } from "../auth.service";
import { Subscription } from "rxjs";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { StorageService } from "../../shared/services/storage.service";
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { Roles } from "../../shared/models";
import { FooterComponent } from "../../shared/components/footer/footer.component";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, TranslateModule, SpinnerComponent, FooterComponent],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  public show: boolean = false;
  public loginForm: FormGroup;
  protected subscriptions: Subscription[] = [];
  isLoading: boolean = false;

  constructor(private fb: FormBuilder, public router: Router, private authService: AuthService, private storageService: StorageService, private translateService: TranslateService) {
    const userData = this.storageService.getFromLocalOrSessionStorage("user");

    if (userData != null) {
      router.navigate(["admin"]);
    }

    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required], // secret
      rememberMe: [true],
    });
  }

  showPassword() {
    this.show = !this.show;
  }

  login() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      const { email, password, rememberMe } = this.loginForm.value;
      const sub = this.authService.login(email, password).subscribe({
        next: (res: any) => {
          const user = {
            email: res.data.email,
            token: res.data.token,
            is_admin: res.data.is_admin,
            role: res.data.role
          };
          this.authService.setUserData(user, rememberMe);
          if (res.data.first_password == 1) {
            let tempUser = {
              email: res.data.email,
              token: res.data.token,
            };
            sessionStorage.setItem("tempUser", JSON.stringify(tempUser));
            this.router.navigate(["/auth/reset-password/new-password"], 
              {
                state: { oldPwd: password }
              }
            );
          } else {
            const userRole = this.authService.getRole();
            if (Object.values(Roles).includes(userRole)) {
              this.router.navigate(["/admin"]);
            } else {
              this.router.navigateByUrl("/auth/login");
            }
          }
        },
        error: (error) => {
          this.isLoading = false;
        }
      });
      this.subscriptions.push(sub);
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
